import { render, staticRenderFns } from "./TabPICBranch.vue?vue&type=template&id=f492633e"
import script from "./TabPICBranch.vue?vue&type=script&lang=js"
export * from "./TabPICBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports